import { FC, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';

import clsx from 'clsx';

import ru from 'date-fns/locale/ru';
import moment from 'moment';

import {
	actionClientDeclineReport,
	actionClientRequestReport,
	actionClientAcceptReport,
	actionConfirmReportClaim,
	actionDeclineReportClaim,
	actionUpdateNotesClaim,
	actionCancelReportClaim,
	actionUpdateFixDate,
	actionDeclineRate,
	actionAcceptRate,
} from '../../../../redux/action/userSingleReport/actionUserSingleReport';
import { reducerReportStatus } from '../../../../redux/reducer/userSingleReport/reducers/userSingleReport';
import { calculateProgress } from '../../../../utils/calculateUploadingProgress';
import { formatDateTime, getCorrectDate } from '../../../../utils/formatDate';
import { AppDispatch } from '../../../../redux/reducer/store';

import Select from '../../../custom/select/select';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';
import CheckMark from '../../../../assets/icons/checkMark.svg';
import Close from '../../../../assets/icons/close.svg';
import ArrowIcon from '../../../../assets/icons/chevron.svg';

import { IReportCriteriasOptions } from '../../../../types/reportsInterfaces';
import { IUserOptions } from '../../../../types/interfaces';

const statusOptions = [
	{ value: 'Rejected', label: 'Отклонен' },
	{ value: 'Claim', label: 'Претензия в обработке' },
	{ value: 'Accepted', label: 'Принят' },
	{ value: 'Recommendation', label: 'Рекомедация в обработке' },
];

const ClientReportCheckTableSection: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { clientReportCheckList, report, list } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	const inputRef = useRef<HTMLInputElement>(null);

	const currentDate = moment();
	const futureDate = currentDate.add(48, 'hours').set({ hour: 23, minute: 50 });

	const [isClientFixedOpen, setIsClientFixedOpen] = useState<boolean>(false);
	const [isClientPartiallyDeclineOpen, setIsClientPartiallyDeclineOpen] =
		useState<boolean>(false);
	const [isClientRecFixedRequestOpen, setIsClientRecFixedRequestOpen] =
		useState<boolean>(false);
	const [isClientDeclineRequestOpen, setIsClientDeclineRequestOpen] =
		useState<boolean>(false);
	const [isClientReportApproveOpen, setIsClientReportApproveOpen] =
		useState<boolean>(false);
	const [isClientFixedRequestOpen, setIsClientFixedRequestOpen] =
		useState<boolean>(false);
	const [isClientClaimRequestOpen, setIsClientClaimRequestOpen] =
		useState<boolean>(false);
	const [isClientRecNotFixedOpen, setIsClientRecNotFixedOpen] =
		useState<boolean>(false);
	const [isClientReportClaimOpen, setIsClientReportClaimOpen] =
		useState<boolean>(false);
	const [isOpenClientReportCheck, setIsOpenClientReportCheck] =
		useState<boolean>(false);
	const [isClientDeclineRecOpen, setIsClientDeclineRecOpen] =
		useState<boolean>(false);
	const [isClientReportRecOpen, setIsClientReportRecOpen] =
		useState<boolean>(false);
	const [isClientFixedRecOpen, setIsClientFixedRecOpen] =
		useState<boolean>(false);
	const [isClientDeclinedOpen, setIsClintDeclinedOpen] =
		useState<boolean>(false);
	const [isOpenUpdateFixDate, setIsOpenUpdateFixDate] =
		useState<boolean>(false);
	const [isDeclineInputError, setIsDeclineInputError] =
		useState<boolean>(false);

	const [selectedCheckboxesId, setSelectedCheckboxId] = useState<number[]>([]);
	const [selectedUpdatedDate, setSelectedUpdatedDate] = useState<Date>(
		new Date()
	);
    const [selectedStatusOption, setSelectedStatusOption] = useState<string>('Rejected');
    const [reportCriteriasOptions, setReportCriteriasOptions] = useState<IReportCriteriasOptions[]>([]);
	const [declineRecInputValue, setDeclineRecInputValue] = useState<string>('');
	const [presentationComment, setPresentationComment] = useState<string>(report && report?.rateModel?.notes);
	const [selectedDate, setSelectedDate] = useState<Date>(futureDate.toDate());
	const [uploadProgress, setUploadProgress] = useState<number[]>([]);
	const [displayFixDate, setDisplayFixDate] = useState<string>('');
	const [commentValue, setCommentValue] = useState<string>('');
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [isError, setIsError] = useState<boolean>(false);
	const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

	useEffect(() => {
		registerLocale('ru', ru);
	}, []);

	useEffect(() => {
		const reportStatus =
			report && Object.keys(report?.rateModel?.rateStatus).toString();

		const statusActions: any = {
			Recommendation: {
				setState: setIsClientReportRecOpen,
			},
			Claim: {
				setState: setIsClientReportClaimOpen,
			},
			Accepted: {
				setState: setIsClientReportApproveOpen,
			},
			ClaimRequest: {
				setState: setIsClientClaimRequestOpen,
			},
			ClaimDeclined: {
				setState: setIsClientDeclineRequestOpen,
			},
			RecommendationFixedRequest: {
				setState: setIsClientRecFixedRequestOpen,
			},
			RecommendationFixed: {
				setState: setIsClientFixedRecOpen,
			},
			RecommendationDeclined: {
				setState: setIsClientDeclineRecOpen,
			},
			PartiallyDeclined: {
				setState: setIsClientPartiallyDeclineOpen,
			},
			Fixed: {
				setState: setIsClientFixedOpen,
			},
			FixedRequest: {
				setState: setIsClientFixedRequestOpen,
			},
			RecommendationNotFixed: {
				setState: setIsClientRecNotFixedOpen,
			},
			Declined: {
				setState: setIsClintDeclinedOpen,
			},
			NotChecked: {},
		};

		if (reportStatus) {
			resetSections();

			const statusAction = statusActions[reportStatus];

			if (!!Object.keys(statusAction).length) {
				setIsOpenClientReportCheck(true);

				if (reportStatus === 'ClaimRequest') {
					setSelectedUpdatedDate(
						new Date(report && report?.rateModel?.fixDate)
					);
					setDisplayFixDate(report && report?.rateModel?.fixDate);
				}

				statusAction.setState(true);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [report?.rateModel?.rateStatus, report]);

	useEffect(() => {
		const uploadRequests: XMLHttpRequest[] = [];

		selectedFiles.forEach((file: File, index: number) => {
			const formData = new FormData();
			formData.append('file', file);

			const xhr = new XMLHttpRequest();
			xhr.upload.addEventListener('progress', event => {
				if (event.lengthComputable) {
					calculateProgress(
						setUploadProgress,
						index,
						event.loaded,
						event.total
					);
				}
			});

			xhr.addEventListener('load', () => {
				calculateProgress(setUploadProgress, index, file.size, file.size);
			});

			xhr.open('POST', '/upload-endpoint');
			xhr.send(formData);
			uploadRequests.push(xhr);
		});

		return () => {
			uploadRequests.forEach(xhr => xhr.abort());
		};
	}, [selectedFiles]);

    const getClientReportCheckList = (status: string): IReportCriteriasOptions[] => {
        return clientReportCheckList?.filter((o: IReportCriteriasOptions) => {
            const isAvailableOsa = report.skus?.some((sku: any) => sku.signal && sku.signal.hasOwnProperty("isAvailableOsa"));

            if (status === 'Rejected') {
                return (o.rateClaim || o.rateRef) || (isAvailableOsa && o.rateOsa);
            } else if (status === 'Claim') {
                return o.rateClaim || (isAvailableOsa && o.rateOsa)
            } else if (status === 'Accepted') {
                return o.rateAccept || (isAvailableOsa && o.rateOsa)
            } else if (status === 'Recommendation') {
                return o.rateRef || (isAvailableOsa && o.rateOsa)
            } else {
                return false;
            }

        }) || [];
    };

    const handleStatusChange = (event: { value: string }) => {
        setSelectedStatusOption(event.value);
        setIsError(false);
        setSelectedCheckboxId([]);
        setReportCriteriasOptions(getClientReportCheckList(event.value))
    };

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checkboxId = parseInt(event.target.value);

		if (selectedCheckboxesId.includes(checkboxId)) {
			setSelectedCheckboxId(
				selectedCheckboxesId.filter(id => id !== checkboxId)
			);
		} else {
			setSelectedCheckboxId([...selectedCheckboxesId, checkboxId]);
		}

		setIsError(false);
	};

	const handleDatePickerChange = (date: Date) => {
		setSelectedDate(date);
	};

	const handleUpdateDatePickerChange = (date: Date) => {
		setSelectedUpdatedDate(date);
	};

	const handleClickUpdateDateAcceptBtn = () => {
		const newDate = new Date(selectedUpdatedDate).toISOString();

		dispatch(
			actionUpdateFixDate({
				reportId: {
					id: report && report.reportId.id,
					name: '',
				},
				expectedFixDate: getCorrectDate(selectedUpdatedDate),
			})
		).then(() => {
			setDisplayFixDate(newDate);
			setIsOpenUpdateFixDate(false);
		});
	};

	const handleClickUpdateDateCancelBtn = () => {
		setSelectedUpdatedDate(new Date(report && report?.rateModel?.fixDate));
		setIsOpenUpdateFixDate(false);
	};

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files;
		if (files) {
			const filesArray = Array.from(files) as File[];
			setSelectedFiles([...selectedFiles, ...filesArray]);
		}
	};

	const handleClickInternalLink = () => {
		dispatch(
			actionCancelReportClaim({
				reportId: {
					id: report && report.reportId.id,
					name: '',
				},
			})
		).then(() => {
			resetSections();
		});
	};

	const resetSections = () => {
		setIsClientPartiallyDeclineOpen(false);
		setIsClientRecFixedRequestOpen(false);
		setIsClientDeclineRequestOpen(false);
		setSelectedDate(futureDate.toDate());
		setIsClientReportApproveOpen(false);
		setSelectedStatusOption('Rejected');
		setIsClientClaimRequestOpen(false);
		setIsClientFixedRequestOpen(false);
		setIsClientReportClaimOpen(false);
		setIsOpenClientReportCheck(false);
		setIsClientRecNotFixedOpen(false);
		setIsClientDeclineRecOpen(false);
		setIsClientReportRecOpen(false);
		setIsClientFixedRecOpen(false);
		setIsClintDeclinedOpen(false);
		setIsClientFixedOpen(false);
		setSelectedCheckboxId([]);
		setSelectedFiles([]);
		setCommentValue('');
	};

    const validateForm = (): boolean => {
        let isValid = true;
        if (selectedStatusOption === 'Accepted') {
            if (selectedCheckboxesId?.length) {
                const isCommentRequired = clientReportCheckList.filter((o: IReportCriteriasOptions) => {
                    return selectedCheckboxesId.find((id) => id === o.reason.id) && o.rateAcceptNote
                }).length > 0;

                if (isCommentRequired && !(commentValue?.length > 0)) {
                    setErrorMessage('Нужно указать комментарий');
                    setIsError(true);
                    isValid = false;
                }
            }
        } else if (selectedStatusOption === 'Rejected') {
            if (!selectedCheckboxesId?.length) {
                setErrorMessage('Нужно указать причину');
                setIsError(true);
                isValid = false;
            } else {
                const isCommentRequired = clientReportCheckList.filter((o: IReportCriteriasOptions) => {
                    return selectedCheckboxesId.find((id) => id === o.reason.id) && (o.rateClaimNote || o.rateRefNote)
                }).length > 0;

                if (isCommentRequired && !(commentValue?.length > 0)) {
                    setErrorMessage('Нужно указать комментарий');
                    setIsError(true);
                    isValid = false;
                }
            }
        } else {
            if (!selectedCheckboxesId?.length) {
                setErrorMessage('Нужно указать причину');
                setIsError(true);
                isValid = false;
            } else {
                const isCommentRequired = clientReportCheckList.filter((o: IReportCriteriasOptions) => {
                    if (selectedStatusOption === 'Claim') {
                        return selectedCheckboxesId.find((id) => id === o.reason.id) && o.rateClaimNote
                    } else {
                        return selectedCheckboxesId.find((id) => id === o.reason.id) && o.rateRefNote
                    }
                }).length > 0;

                if (isCommentRequired && !(commentValue?.length > 0)) {
                    setErrorMessage('Нужно указать комментарий');
                    setIsError(true);
                    isValid = false;
                }
            }
        }
        return isValid;
    };

    const handleClickFormBtn = () => {
        if (validateForm()) {
            if (selectedStatusOption === 'Accepted') {
                    setIsClientReportApproveOpen(true);
                    dispatch(
                        actionClientAcceptReport({
                                                     reportId: {
                                                         id: report && report.reportId.id,
                                                         name: '',
                                                     },
                                                     reviewReasons: selectedCheckboxesId.map((value: number) => {
                                                         return {
                                                             id: value,
                                                         };
                                                     }),
                                                     rateNote: commentValue,
                                                     checkType: 'DISTANCE',
                                                 })
                    );
            } else if (selectedStatusOption === 'Rejected') {
                if (report && report.reviewModel.reviewStatus !== 'Revision') {
                    dispatch(
                        actionClientDeclineReport(
                            {
                                reportId: {
                                    id: report && report.reportId.id,
                                    name: '',
                                },
                                reviewReasons: selectedCheckboxesId.map((value: number) => {
                                    return {
                                        id: value,
                                    };
                                }),
                                notes: commentValue,
                                checkType: 'DISTANCE',
                            },
                            selectedFiles
                        )
                    );
                } else {
                    dispatch(
                        reducerReportStatus({
                                                status: 0,
                                                requestPurpose: 'declineRateStatus',
                                            })
                    );
                    resetSections();
                }
            } else {
                selectedStatusOption === 'Claim'
                ? setIsClientReportClaimOpen(true)
                : setIsClientReportRecOpen(true);

                dispatch(
                    actionClientRequestReport(
                        {
                            reportId: {
                                id: report && report.reportId.id,
                            },
                            reviewReasons: selectedCheckboxesId.map((value: number) => {
                                return {
                                    id: value,
                                };
                            }),
                            notes: commentValue,
                            checkType: 'DISTANCE',
                            claimType:
                                selectedStatusOption === 'Claim' ? 'Claim' : 'Recommendation',
                            expectedFixDate: getCorrectDate(selectedDate),
                        },
                        selectedFiles
                    )
                )
            }
        }

    };

	const handleCancelClientReportCheck = () => {
		setSelectedDate(futureDate.toDate());
		setSelectedStatusOption('Rejected');
		setIsOpenClientReportCheck(false);
		setSelectedCheckboxId([]);
		setSelectedFiles([]);
		setCommentValue('');
	};

	const handleClickConfirmClaimBtn = () => {
		dispatch(
			actionConfirmReportClaim({
				reportId: {
					id: report && report.reportId.id,
					name: '',
				},
			})
		).then(() => {
			setIsClientClaimRequestOpen(false);
			setIsClientReportClaimOpen(true);
		});
	};

	const handleKeyDownCommentValue = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			dispatch(actionUpdateNotesClaim({
				reportId: {
					id: report && report.reportId.id,
					name: '',
				},
				notes: presentationComment,
			}));
		}
	};

	const handleClickDeclineClaimBtn = () => {
		dispatch(
			actionDeclineReportClaim({
				reportId: {
					id: report && report.reportId.id,
					name: '',
				},
				notes: presentationComment,
			})
		).then(() => {
			setIsClientDeclineRequestOpen(true);
			setIsClientClaimRequestOpen(false);
		});
	};

	const handleClickAcceptFixedRequestBtn = (purpose: string) => {
		dispatch(
			actionAcceptRate({
				reportId: {
					id: report && report?.reportId.id,
				},
				rateNote: '',
				checkType: 'DISTANCE',
			})
		).then(() => {
			if (purpose === 'fixed') {
				setIsClientFixedRequestOpen(false);
			} else {
				setIsClientRecFixedRequestOpen(false);
				setIsClientFixedRecOpen(true);
			}
		});
	};

	const handleClickDeclineFixedRequestBtn = (purpose: string) => {
		if (!declineRecInputValue) {
			setIsDeclineInputError(true);
		} else {
			dispatch(
				actionDeclineRate({
					reportId: {
						id: report && report?.reportId.id,
					},
					rateNote: declineRecInputValue,
					checkType: 'DISTANCE',
				})
			).then(() => {
				if (purpose === 'fixed') {
					setIsClientFixedRequestOpen(false);
				} else {
					setIsClientRecFixedRequestOpen(false);
					setIsClientDeclineRecOpen(true);
				}
			});
		}
	};

	const handleChangeDeclineRecCommentValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDeclineRecInputValue(event.target.value);
		setIsDeclineInputError(false);
	};

	const handleChangePresentationComment = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPresentationComment(event.target.value);
		setIsDeclineInputError(false);
	};

	const isAllSectionsClosed =
		!isClientPartiallyDeclineOpen &&
		!isClientRecFixedRequestOpen &&
		!isClientDeclineRequestOpen &&
		!isClientReportApproveOpen &&
		!isClientClaimRequestOpen &&
		!isClientFixedRequestOpen &&
		!isClientReportClaimOpen &&
		!isClientRecNotFixedOpen &&
		!isClientDeclineRecOpen &&
		!isClientReportRecOpen &&
		!isClientFixedRecOpen &&
		!isClientDeclinedOpen &&
		!isClientFixedOpen;

	const rateStatus = report && report?.rateModel?.rateStatus;
	const rateNotes = report && report?.rateModel?.rateNotes;
	const reasons = report && report?.rateModel?.reasons;
	const fixDate = report && report?.rateModel?.fixDate;
	const notes = report && report?.rateModel?.notes;
	const date = report && report?.rateModel?.date;

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (inputRef.current && !inputRef.current.contains(e.target as Node)) {
				if (presentationComment !== notes && presentationComment !== null) {
					dispatch(actionUpdateNotesClaim({
						reportId: {
							id: report && report.reportId.id,
							name: '',
						},
						notes: presentationComment,
					}));
				}
			}
		}
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [report, notes, presentationComment, dispatch]);

    useEffect(() => {
        let reportCheckList = getClientReportCheckList(selectedStatusOption);
        setReportCriteriasOptions(reportCheckList)
        // eslint-disable-next-line
    }, [list, clientReportCheckList]);

	return (
		<div
			className={
				isOpenClientReportCheck
					? 'customer__check_activeSection'
					: 'client__check_section'
			}
		>
			{isAllSectionsClosed && (
				<>
					{!(claims.includes('admin') ||
						claims.includes('reports:rate:create')) ? (
						<div className='customerReport__check_block'>
							<span style={{color: isOpenClientReportCheck ? 'blue' : 'yellow'}} className='section__title'>Оценка отчета клиентом</span>
							<div className='test'>Отчет еще не оценен</div>
						</div>
					) : (
						<>
							<span style={{color: isOpenClientReportCheck ? 'black' : 'white'}} className='section__title'>Оценка отчета клиентом</span>
						</>
					)}
				</>
			)}
			{isError && (
				<div className='report__error_block'>
					<div className='error__block_row'>
						<span>
							Вы должны исправить следующие ошибки прежде, чем продолжить.
						</span>
						<CloseIcon
							onClick={() => setIsError(false)}
							className='close__icon'
						/>
					</div>
					<ul className='error__list'>
						<li>{errorMessage}</li>
					</ul>
				</div>
			)}

			{!isOpenClientReportCheck && isAllSectionsClosed && (claims.includes('admin') ||
				claims.includes('reports:rate:create')) && (
					<>
						<button className="planograms__btn" onClick={() => setIsOpenClientReportCheck(true)}>Оценить работу</button>
					</>
				)}

			{isOpenClientReportCheck && isAllSectionsClosed && (
				<div className='report__check_wrapper'>
					<div className='check__wrapper_list'>
						<span>Статус оценки:</span>
						<div className='wrapper__list_block'>
							<Select
								propsChange={handleStatusChange}
								defaultValue={statusOptions[0]}
								className='check__select'
								options={statusOptions}
								value={statusOptions.find(
									option => option.value === selectedStatusOption
								)}
							/>
						</div>
					</div>
					<div className='check__wrapper_list'>
						<span>Причины:</span>
						<div className='check__list_block'>
							{list && clientReportCheckList && reportCriteriasOptions?.map((item: IReportCriteriasOptions, index: number) => (
									<div key={index} className='check__list_elem'>
										<label className='checkbox__container'>
											<input
												checked={selectedCheckboxesId.includes(item.reason.id)}
												onChange={handleCheckboxChange}
												value={item.reason.id}
												name={item.reason.name}
												type='checkbox'
											/>
											<span className='checkmark'></span>
										</label>
										{item.reason.name}
									</div>
								))}
						</div>
					</div>
					<div className='check__wrapper_list'>
						<span>Комментарий:</span>
						<textarea
							onChange={event => setCommentValue(event.target.value)}
							className='check__comment_textfield'
							value={commentValue}
						></textarea>
					</div>
					<div className='check__wrapper_list'>
						<span>Дата исправления:</span>
						<div className='check__data_wrapper'>
							<DatePicker
								onKeyDown={event => event.preventDefault()}
								onChange={handleDatePickerChange}
								dateFormat='dd.MM.yyyy HH:mm'
								selected={selectedDate}
								timeCaption='Время'
								popperPlacement='top'
								showTimeSelect
								locale={ru}
								name='date'
							/>
						</div>
					</div>
					<div className='check__wrapper_list'>
						<span>Добавьте файлы:</span>
						<input
							className='download__file_input'
							onChange={handleFileChange}
							placeholder='Загрузить'
							type='file'
							name='checkFiles'
							id='checkFiles'
							multiple
						/>
						<label htmlFor='checkFiles' className='file__label'>
							Загрузить
						</label>
					</div>
					<div className='check__files__list'>
						{selectedFiles.map((file: File, index: number) => {
							const fileSize = (file.size / (1024 * 1024)).toFixed(2);
							const progress = uploadProgress[index] || 0;

							return (
								<div key={index} className='file__list_elem'>
									<div className='file__list_dot'></div>
									<span className='file__name'>{file.name}</span>
									<span>
										{progress.toFixed(0)}% от {fileSize} MB
									</span>
									<span
										onClick={() =>
											setSelectedFiles(
												selectedFiles.filter(
													(elem: File) => elem.name !== file.name
												)
											)
										}
										className='cancel__file_btn'
									>
										Отменить
									</span>
								</div>
							);
						})}
					</div>
					<div className='check__wrapper_list'>
						<button className='form__btn' onClick={handleClickFormBtn}>
							Сформировать
						</button>
						<button
							className='cancel__btn'
							onClick={handleCancelClientReportCheck}
						>
							Отмена
						</button>
					</div>
				</div>
			)}
			{isClientReportApproveOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									{report && Object.values(rateStatus)}
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						{reasons[0] !== null && (
							<div className='internal__check_elem'>
								<span>Критерий:</span>
								<span>{reasons.join(', ')}</span>
							</div>
						)}
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}

						{rateNotes && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{rateNotes}</span>
							</div>
						)}
					</div>
				</div>
			)}
			{isClientDeclinedOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Отклонен
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						{reasons[0] !== null && (
							<div className='internal__check_elem'>
								<span>Критерий:</span>
								<span>{reasons.join(', ')}</span>
							</div>
						)}
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						{rateNotes && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{rateNotes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{(isClientReportClaimOpen || isClientReportRecOpen) && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									{report && Object.values(rateStatus)}
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>
									<input
										className='internal__check_input'
										type='text'
										readOnly
										disabled
										defaultValue={notes}
									/>
								</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientClaimRequestOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Претензия (тр. подтверждения)
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>
									<input
										className='internal__check_input'
										type='text'
										disabled={!claims.includes('admin')}
										defaultValue={notes}
										onChange={handleChangePresentationComment}
										onKeyDown={handleKeyDownCommentValue}
										ref={inputRef}
									/>
								</span>
							</div>
						)}
						<div
							className={
								isOpenUpdateFixDate
									? 'internal__update_elem'
									: 'internal__check_elemDate'
							}
						>
							<span>Исправить до:</span>
							{!isOpenUpdateFixDate && fixDate && (
								<span
									className='claim__request_fixDate'
									onClick={() => setIsOpenUpdateFixDate(!isOpenUpdateFixDate)}
								>
									{formatDateTime(displayFixDate)}
								</span>
							)}
							{isOpenUpdateFixDate && (
								<div className='update__date_popup'>
									<div className='claim__update_date'>
										<DatePicker
											onKeyDown={event => event.preventDefault()}
											onChange={handleUpdateDatePickerChange}
											dateFormat='dd.MM.yyyy HH:mm'
											selected={selectedUpdatedDate}
											popperPlacement='top'
											minDate={new Date()}
											timeCaption='Время'
											showTimeSelect
											locale={ru}
											name='date'
										/>
									</div>
									<div className='btns__block'>
										<button
											onClick={handleClickUpdateDateAcceptBtn}
											className='accept__name_btn'
										>
											<img
												className='check__mark_icon'
												src={CheckMark}
												alt='accept'
											/>
										</button>
										<button
											onClick={handleClickUpdateDateCancelBtn}
											className='cancel__name_btn'
										>
											<img src={Close} alt='close' />
										</button>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className='btns__block'>
						<button
							className='accept__claim'
							onClick={handleClickConfirmClaimBtn}
						>
							Утвердить претензию
						</button>
						<button
							className='reject__claim'
							onClick={handleClickDeclineClaimBtn}
						>
							Отклонить претензию
						</button>
					</div>
				</div>
			)}
			{isClientDeclineRequestOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Претензия отклонена
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						{rateNotes && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{rateNotes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientRecFixedRequestOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Рекомендация проработана
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
					<div className='btns__block'>
						<button
							className='reject__claim'
							onClick={() => handleClickAcceptFixedRequestBtn('recommendation')}
						>
							Принять исправление
						</button>
						<button
							className='accept__claim'
							onClick={() =>
								handleClickDeclineFixedRequestBtn('recommendation')
							}
						>
							Отклонить исправление
						</button>
					</div>
					<div className='rec__fixed_commentBlock'>
						<span className={isDeclineInputError ? 'decline__error_title' : ''}>
							Комментарий к проверке
						</span>
						<div className='rec__fixed_inputBlock'>
							<div className='decline__input_errorBlock'>
								<input
									type='text'
									className={
										isDeclineInputError
											? 'error__decline_input'
											: 'internal__check_input'
									}
									onChange={handleChangeDeclineRecCommentValue}
								/>
								{isDeclineInputError && (
									<span className='decline__error_message'>
										Необходимо заполнить причину отклонения
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
			{isClientFixedRecOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Рекомендация выполнена
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientDeclineRecOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Рекомендация отклонена
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						{(declineRecInputValue || rateNotes) && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{declineRecInputValue || rateNotes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientRecNotFixedOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Рекомендация не выполнена
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{(declineRecInputValue || notes) && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{declineRecInputValue || notes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientPartiallyDeclineOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Отклонен (частично)
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons?.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						{rateNotes && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{rateNotes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
			{isClientFixedRequestOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Исправлен (тр. подтверждения)
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
					<div className='btns__block'>
						<button
							className='reject__claim'
							onClick={() => handleClickAcceptFixedRequestBtn('fixed')}
						>
							Принять исправление
						</button>
						<button
							className='accept__claim'
							onClick={() => handleClickDeclineFixedRequestBtn('fixed')}
						>
							Отклонить исправление
						</button>
					</div>
					<div className='rec__fixed_commentBlock'>
						<span className={isDeclineInputError ? 'decline__error_title' : ''}>
							Комментарий к проверке
						</span>Изменения по внутренней проверке
						<div className='rec__fixed_inputBlock'>
							<div className='decline__input_errorBlock'>
								<input
									type='text'
									className={
										isDeclineInputError
											? 'error__decline_input'
											: 'internal__check_input'
									}
									onChange={handleChangeDeclineRecCommentValue}
								/>
								{isDeclineInputError && (
									<span className='decline__error_message'>
										Необходимо заполнить причину отклонения
									</span>
								)}
							</div>
							<span>Изменения по внутренней проверке</span>
						</div>
					</div>
				</div>
			)}
			{isClientFixedOpen && (
				<div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
					<span className='section__title inside'>Отчет проверен клиентом</span>
					<button
						className='sectionData_button'
						onClick={() => setIsVisibleData(!isVisibleData)}
					>
						<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
					</button>
					<div className='customer__check_block'>
						<div className='internal__check_elem'>
							<span>Статус:</span>
							<span className='internal__link'>
								<span
									onClick={() => {
										if (
											claims.includes('admin') ||
											claims.includes('reports:rate:create')
										) {
											handleClickInternalLink();
										}
									}}
									className={clsx({
										link__content:
											claims.includes('admin') ||
											claims.includes('reports:rate:create'),
									})}
								>
									Исправлен
								</span>
							</span>
						</div>
						<div className='internal__check_elem'>
							<span>Дата:</span>
							<span>{date && formatDateTime(date)}</span>
						</div>
						<div className='internal__check_elem'>
							<span>Критерий:</span>
							<span>{reasons.join(', ')}</span>
						</div>
						{notes && (
							<div className='internal__check_elem'>
								<span>Комментарий:</span>
								<span>{notes}</span>
							</div>
						)}
						{rateNotes && (
							<div className='internal__check_elem'>
								<span>Комментарий при проверке:</span>
								<span>{rateNotes}</span>
							</div>
						)}
						<div className='internal__check_elem'>
							<span>Исправить до:</span>
							<span>{fixDate && formatDateTime(fixDate)}</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ClientReportCheckTableSection;
